module.exports = __webpack_public_path__ + "img/complement-services.f688d399.png";